import SimpleLightbox from 'simplelightbox'

export class Lightbox {
  constructor () {
    document.querySelectorAll('.s-single__builder-gallery').forEach((gallery) => {
      const links = gallery.querySelectorAll('a.lightbox')

      if (!links.length) {
        return
      }

      new SimpleLightbox(links, {
        captionsData: 'title',
        captionSelector: 'self',
      })
    })
  }
}
